import React, { useState } from 'react';
import styled from 'styled-components';
import HeaderItem from './components/HeaderItem';

import { useTranslation } from 'gatsby-plugin-react-i18next';
import NavigationColor from 'utils/constants/NavigationColor';
import LanguageDropdown from 'components/LanguageDropdown';

const NavigationList = styled.ul`
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
`;

interface Props {
  variant: NavigationColor.LIGHT | NavigationColor.DARK;
}

const HeaderMenu = ({ variant }: Props) => {
  const { t } = useTranslation();

  return (
    <nav>
      <NavigationList>
        <HeaderItem variant={variant} href="https://www.safebrok.com">
          {t('homepage.navbar.safebrok_seguros')}
        </HeaderItem>
        <HeaderItem
          active
          variant={variant}
          href="https://www.safebrokeurope.com"
        >
          {t('homepage.navbar.safebrok_europe')}
        </HeaderItem>
        <LanguageDropdown variant={variant} />
      </NavigationList>
    </nav>
  );
};

export default HeaderMenu;
